import React from "react";
import { getFormattedImageLink } from "Utils";
import arrowdown from "./images/arrow-down.svg";
import department from "./images/department-iocn.svg";
import location from "./images/location-icon.svg";
import sumhrlogo from "./images/sumhr-logo.svg";
import "./style.css";

class PreviewCareerPageComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sitePreview: this.props.sitePreview,
      coverPhoto: [],
      aboutUs: [],
      ourCulture: [],
      ourValues: [],
      overview: [],
      benefits: [],
      teamStructure: [],
      officeLocation: [],
      aboutusimage1: null,
      aboutusimage2: null,
      aboutusimage3: null,
      ourcultureimage1: null,
      ourcultureimage2: null,
      ourcultureimage3: null,
    };
  }

  componentDidMount() {
    const coverPhoto =
      this.props.sitePreview &&
      this.props.sitePreview.filter((x) => x.sectiontypeid == 1);
    const aboutUs =
      this.props.sitePreview &&
      this.props.sitePreview.filter((x) => x.sectiontypeid == 2);
    const ourCulture =
      this.props.sitePreview &&
      this.props.sitePreview.filter((x) => x.sectiontypeid == 3);
    const ourValues =
      this.props.sitePreview &&
      this.props.sitePreview.filter((x) => x.sectiontypeid == 4);
    const overview =
      this.props.sitePreview &&
      this.props.sitePreview.filter((x) => x.sectiontypeid == 5);
    const benefits =
      this.props.sitePreview &&
      this.props.sitePreview.filter((x) => x.sectiontypeid == 6);
    const teamStructure =
      this.props.sitePreview &&
      this.props.sitePreview.filter((x) => x.sectiontypeid == 7);
    const officeLocation =
      this.props.sitePreview &&
      this.props.sitePreview.filter((x) => x.sectiontypeid == 8);
    const aboutusimage1 =
      aboutUs &&
      aboutUs[0] &&
      aboutUs[0].sectiondetail[0] &&
      aboutUs[0].sectiondetail[0].documentpath;
    const aboutusimage2 =
      aboutUs &&
      aboutUs[0] &&
      aboutUs[0].sectiondetail[1] &&
      aboutUs[0].sectiondetail[1].documentpath;
    const aboutusimage3 =
      aboutUs &&
      aboutUs[0] &&
      aboutUs[0].sectiondetail[2] &&
      aboutUs[0].sectiondetail[2].documentpath;
    const ourcultureimage1 =
      ourCulture &&
      ourCulture[0] &&
      ourCulture[0].sectiondetail[0] &&
      ourCulture[0].sectiondetail[0].documentpath;
    const ourcultureimage2 =
      ourCulture &&
      ourCulture[0] &&
      ourCulture[0].sectiondetail[1] &&
      ourCulture[0].sectiondetail[1].documentpath;
    const ourcultureimage3 =
      ourCulture &&
      ourCulture[0] &&
      ourCulture[0].sectiondetail[2] &&
      ourCulture[0].sectiondetail[2].documentpath;

    this.setState({
      coverPhoto,
      aboutUs,
      ourCulture,
      ourValues,
      overview,
      benefits,
      teamStructure,
      officeLocation,
      aboutusimage1,
      aboutusimage2,
      aboutusimage3,
      ourcultureimage1,
      ourcultureimage2,
      ourcultureimage3,
    });
  }

  render() {
    const {
      coverPhoto,
      aboutUs,
      ourCulture,
      ourValues,
      overview,
      benefits,
      teamStructure,
      officeLocation,
      aboutusimage1,
      aboutusimage2,
      aboutusimage3,
    } = this.state;
    const ourCultureSectionBody = {
      __html: ourCulture && ourCulture[0] && ourCulture[0].sectionbody,
    };
    const aboutUsSectionBody = {
      __html: aboutUs && aboutUs[0] && aboutUs[0].sectionbody,
    };

    return (
      <div>
        <div>
          {coverPhoto && coverPhoto.length > 0 && (
            <div className="c-MuiGrid-root c-MuiGrid-container">
              <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-12">
                <div
                  className="c-hero-container"
                  style={{
                    backgroundImage:
                      coverPhoto &&
                      coverPhoto[0] &&
                      coverPhoto[0].sectiondetail[0] &&
                      coverPhoto[0].sectiondetail[0].documentpath
                        ? `url(${getFormattedImageLink(
                            coverPhoto[0].sectiondetail[0].documentpath,
                          )})`
                        : "",
                  }}
                >
                  <div style={{ position: "absolute", top: 64 }}>
                    <img src={sumhrlogo} />
                  </div>
                  <h1
                    style={{
                      color: "rgb(255, 255, 255)",
                      fontSize: 64,
                      width: "50%",
                      marginTop: 0,
                      marginBottom: 0,
                    }}
                  >
                    {coverPhoto && coverPhoto[0] && coverPhoto[0].title}
                  </h1>
                  <div
                    style={{
                      width: "50%",
                      display: "inline-flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <p
                      style={{
                        color: "rgb(255, 255, 255)",
                        fontSize: 24,
                        marginRight: 16,
                        fontWeight: "bold",
                      }}
                    >
                      See open positions
                    </p>
                    <button
                      style={{ border: "none", background: "transparent" }}
                      // onClick={this.focusToPositions}
                    >
                      <div className="c-go-to-bottom">
                        <img src={arrowdown} />
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div style={{ padding: 64 }}>
            {/* ABOUT US */}
            {aboutUs && aboutUs.length > 0 && (
              <div
                className="c-MuiGrid-root c-MuiGrid-container c-MuiGrid-spacing-xs-3"
                style={{ marginBottom: 64 }}
              >
                <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-8">
                  <p className="c-small-dark-secondary c-margin-bottom-16">
                    About us
                  </p>
                  <h6 className="c-section-title">
                    {aboutUs && aboutUs[0] && aboutUs[0].title}
                  </h6>
                  <p
                    className="c-small-dark-secondary c-margin-bottom-16"
                    dangerouslySetInnerHTML={aboutUsSectionBody}
                  ></p>
                </div>
                <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-4">
                  <div
                    className="c-text-center c-width100 c-position-rel"
                    style={{ height: 284 }}
                  >
                    <div>
                      {aboutusimage1 && (
                        <img
                          src={getFormattedImageLink(aboutusimage1)}
                          height="200"
                          width="200"
                          style={{
                            position: "absolute",
                            border: "1px solid rgb(221, 221, 221)",
                            zIndex: 0,
                            background: "rgb(255, 255, 255)",
                            top: 0,
                            left: 0,
                            display: "block",
                            objectFit: "cover",
                          }}
                        />
                      )}
                      {aboutusimage2 && (
                        <img
                          src={getFormattedImageLink(aboutusimage2)}
                          height="200"
                          width="200"
                          style={{
                            position: "absolute",
                            border: "1px solid rgb(221, 221, 221)",
                            zIndex: 0,
                            background: "rgb(255, 255, 255)",
                            top: 32,
                            left: 64,
                            display: "block",
                            objectFit: "cover",
                          }}
                        />
                      )}
                      {aboutusimage3 && (
                        <img
                          src={getFormattedImageLink(aboutusimage3)}
                          height="200"
                          width="200"
                          style={{
                            border: "1px solid rgb(221, 221, 221)",
                            position: "absolute",
                            zIndex: 2,
                            background: "rgb(255, 255, 255)",
                            top: 82,
                            left: 128,
                            display: "block",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {ourCulture && ourCulture.length > 0 && (
              <div
                className="c-MuiGrid-root c-MuiGrid-container c-MuiGrid-spacing-xs-3"
                style={{ marginBottom: 64 }}
              >
                <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-8">
                  <p className="c-small-dark-secondary c-margin-bottom-16">
                    OUR CULTURE
                  </p>
                  <h6 className="c-section-title">
                    {" "}
                    {ourCulture && ourCulture[0] && ourCulture[0].title}
                  </h6>
                  <p
                    className="c-small-dark-secondary c-margin-bottom-16"
                    dangerouslySetInnerHTML={ourCultureSectionBody}
                  ></p>
                </div>
                <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-4">
                  <div
                    className="c-text-center c-width100 c-position-rel"
                    style={{ height: 284 }}
                  >
                    <div>
                      {this.state.ourcultureimage1 && (
                        <img
                          src={getFormattedImageLink(
                            this.state.ourcultureimage1,
                          )}
                          height="200"
                          width="200"
                          style={{
                            position: "absolute",
                            border: "1px solid rgb(221, 221, 221)",
                            zIndex: 0,
                            background: "rgb(255, 255, 255)",
                            top: 0,
                            left: 0,
                            display: "block",
                            objectFit: "cover",
                          }}
                        />
                      )}
                      {this.state.ourcultureimage2 && (
                        <img
                          src={getFormattedImageLink(
                            this.state.ourcultureimage2,
                          )}
                          height="200"
                          width="200"
                          style={{
                            position: "absolute",
                            border: "1px solid rgb(221, 221, 221)",
                            zIndex: 0,
                            background: "rgb(255, 255, 255)",
                            top: 32,
                            left: 64,
                            display: "block",
                            objectFit: "cover",
                          }}
                        />
                      )}
                      {this.state.ourcultureimage3 && (
                        <img
                          src={getFormattedImageLink(
                            this.state.ourcultureimage3,
                          )}
                          height="200"
                          width="200"
                          style={{
                            border: "1px solid rgb(221, 221, 221)",
                            position: "absolute",
                            zIndex: 2,
                            background: "rgb(255, 255, 255)",
                            top: 82,
                            left: 128,
                            display: "block",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  {/* <div>
                    <video width="320" height="240" controls>
                      <source src="movie.mp4" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div> */}
                </div>
              </div>
            )}

            {ourValues && ourValues.length > 0 && (
              <div style={{ marginBottom: 64 }}>
                <div
                  className="c-MuiGrid-root c-MuiGrid-container"
                  style={{ marginBottom: 24 }}
                >
                  <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-12">
                    <p className="c-small-dark-secondary c-margin-bottom-16">
                      OUR VALUES
                    </p>
                    <h6 className="c-section-title">
                      {ourValues && ourValues[0] && ourValues[0].title}
                    </h6>
                  </div>
                </div>
                <div
                  className="c-MuiGrid-root c-thumbnails c-MuiGrid-container c-MuiGrid-spacing-xs-3"
                  style={{ justifyContent: "center" }}
                >
                  {ourValues &&
                    ourValues[0] &&
                    ourValues[0].sectiondetail.length > 0 &&
                    ourValues[0].sectiondetail.map((item) => (
                      <div className="c-MuiGrid-root c-text-center c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                        <div style={{ height: 160, position: "relative" }}>
                          <img
                            src={getFormattedImageLink(item.documentpath)}
                            height="64"
                            width="64"
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              left: 0,
                              bottom: 0,
                              margin: "auto",
                            }}
                          />
                        </div>
                        <p className="c-large-text-dark-secondary c-t-bold c-margin-bottom-32">
                          {item.title}
                        </p>
                        <p className="c-normal-dark-secondary c-margin-bottom-16">
                          {item.description}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            )}
            {overview && overview.length > 0 && (
              <div style={{ marginBottom: 64 }}>
                <div
                  className="c-MuiGrid-root c-MuiGrid-container"
                  style={{ marginBottom: 24 }}
                >
                  <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-12">
                    <p className="c-small-dark-secondary c-margin-bottom-16">
                      OVERVIEW
                    </p>
                    <h6 className="c-section-title">
                      {overview && overview[0] && overview[0].title}
                    </h6>
                  </div>
                </div>
                <div
                  className="c-MuiGrid-root c-thumbnails c-MuiGrid-container c-MuiGrid-spacing-xs-3"
                  style={{ justifyContent: "center" }}
                >
                  {overview &&
                    overview[0] &&
                    overview[0].sectiondetail.length > 0 &&
                    overview[0].sectiondetail.map((item) => (
                      <div className="c-MuiGrid-root c-text-center c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                        <h3
                          className="c-t-bold c-margin-top-0"
                          style={{
                            color: "rgba(1, 7, 9, 0.7)",
                            fontSize: 48,
                            marginBottom: 8,
                          }}
                        >
                          {item.title}
                        </h3>
                        <p className="c-normal-blue c-margin-bottom-32">
                          {item.description}
                          {String.fromCodePoint(
                            parseInt(item.documentpath, 16),
                          )}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            )}
            {benefits && benefits.length > 0 && (
              <div style={{ marginBottom: 64 }}>
                <div
                  className="c-MuiGrid-root c-MuiGrid-container"
                  style={{ marginBottom: 24 }}
                >
                  <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-12">
                    <p className="c-small-dark-secondary c-margin-bottom-16">
                      BENIFITS
                    </p>
                    <h6 className="c-section-title">
                      {benefits && benefits[0] && benefits[0].title}
                    </h6>
                  </div>
                </div>
                <div
                  className="c-MuiGrid-root c-thumbnails c-MuiGrid-container c-MuiGrid-spacing-xs-3"
                  style={{ justifyContent: "center" }}
                >
                  {benefits &&
                    benefits[0] &&
                    benefits[0].sectiondetail.length > 0 &&
                    benefits[0].sectiondetail.map((item) => (
                      <div className="c-MuiGrid-root c-text-center c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                        <div style={{ height: 160, position: "relative" }}>
                          <img
                            src={getFormattedImageLink(item.documentpath)}
                            height="64"
                            width="64"
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              left: 0,
                              bottom: 0,
                              margin: "auto",
                            }}
                          />
                        </div>
                        <p className="c-large-text-dark-secondary c-margin-bottom-32">
                          {item.title}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {teamStructure && teamStructure.length > 0 && (
              <div style={{ marginBottom: 64 }}>
                <div
                  className="c-MuiGrid-root c-MuiGrid-container"
                  style={{ marginBottom: 24 }}
                >
                  <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-12">
                    <p className="c-small-dark-secondary c-margin-bottom-16">
                      TEAM STRUCTURE
                    </p>
                    <h6 className="c-section-title">
                      {teamStructure &&
                        teamStructure[0] &&
                        teamStructure[0].title}
                    </h6>
                  </div>
                </div>
                <div
                  className="c-MuiGrid-root c-thumbnails c-MuiGrid-container c-MuiGrid-spacing-xs-3"
                  style={{ justifyContent: "center" }}
                >
                  {teamStructure &&
                    teamStructure[0].sectiondetail &&
                    teamStructure[0].sectiondetail.map((item) => (
                      <div className="c-MuiGrid-root c-text-center c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                        <h3
                          className="c-t-bold c-margin-top-0"
                          style={{
                            color: "rgba(1, 7, 9, 0.7)",
                            fontSize: 48,
                            marginBottom: 8,
                          }}
                        >
                          {item.title}
                        </h3>
                        <p className="c-normal-blue c-margin-bottom-32">
                          {item.description}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {officeLocation && officeLocation.length > 0 && (
              <div style={{ marginBottom: 64 }}>
                <div
                  className="c-MuiGrid-root c-MuiGrid-container"
                  style={{ marginBottom: 24 }}
                >
                  <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-12">
                    <p className="c-small-dark-secondary c-margin-bottom-16">
                      OFFICE LOCATIONS
                    </p>
                    <h6 className="c-section-title">
                      {officeLocation &&
                        officeLocation[0] &&
                        officeLocation[0].title}
                    </h6>
                  </div>
                </div>
                <div
                  className="c-MuiGrid-root c-thumbnails c-MuiGrid-container c-MuiGrid-spacing-xs-3"
                  style={{ justifyContent: "center" }}
                >
                  {officeLocation &&
                    officeLocation[0] &&
                    officeLocation[0].sectiondetail &&
                    officeLocation[0].sectiondetail.map((item) => (
                      <div className="c-MuiGrid-root c-text-center c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                        <img
                          src={getFormattedImageLink(item.documentpath)}
                          width="200"
                          height="200"
                          style={{ objectFit: "contain", marginBottom: 8 }}
                        />
                        <p
                          className="c-normal-blue c-t-bold"
                          style={{ marginBottom: 8 }}
                        >
                          {item.title}
                        </p>
                        <p className="c-normal-dark-secondary">
                          {item.officeaddress &&
                            item.officeaddress.addressline1}
                          <br></br>{" "}
                          {item.officeaddress &&
                            item.officeaddress.addressline2}
                          {item.officeaddress.addressline2 && <br></br>}
                          {item.officeaddress &&
                            item.officeaddress.cityname},{" "}
                          {item.officeaddress && item.officeaddress.pincode}{" "}
                          <br></br>
                          {item.officeaddress && item.officeaddress.countryname}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            )}
            <div
              //   ref="positionref"
              style={{ margin: "0px auto", width: "80%" }}
            >
              <div className="c-MuiGrid-root c-thumbnails c-MuiGrid-container c-MuiGrid-spacing-xs-3">
                <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                  <p
                    className="c-large-text-dark-secondary c-t-bold"
                    style={{ fontSize: 22 }}
                  >
                    Open Positions
                  </p>
                </div>
                {/* <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                  <div className="c-search-box c-t-12">
                    <div>
                      <input
                        className=""
                        placeholder="Search"
                        type="text"
                        value=""
                      />
                    </div>
                    <div className="">
                      <svg
                        className="MuiSvgIcon-root MuiSvgIcon-colorDisabled"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                  <div className="c-MuiGrid-root c-MuiGrid-container">
                    <div className="c-MuiGrid-root c-margin-bottom-16 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-12">
                      <div className="c-width100 c-form-element">
                        <select id="cars" name="cars">
                          <option value="All locations">All locations</option>
                          <option value="saab">Saab 95</option>
                          <option value="mercedes">Mercedes SLK</option>
                          <option value="audi">Audi TT</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-3">
                  <div className="c-MuiGrid-root c-MuiGrid-container">
                    <div className="c-MuiGrid-root c-margin-bottom-16 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-12">
                      <div className="c-width100 c-form-element">
                        <select id="cars" name="cars">
                          <option value="All locations">Product</option>
                          <option value="saab">Saab 95</option>
                          <option value="mercedes">Mercedes SLK</option>
                          <option value="audi">Audi TT</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
               */}
              </div>
            </div>
            <div
              className="c-MuiGrid-root c-thumbnails c-MuiGrid-container c-MuiGrid-spacing-xs-3"
              style={{ justifyContent: "flex-start", marginTop: 16 }}
            >
              {this.props.jobTemplates &&
                this.props.jobTemplates.map((item) => (
                  <div
                    className="c-MuiGrid-root c-MuiGrid-item c-MuiGrid-grid-xs-12 c-MuiGrid-grid-sm-12 c-MuiGrid-grid-md-6"
                    // onClick={() => {
                    //   // e.preventDefault();
                    //   // // this.props.history.push("./fgh/1");
                    //   // this.props.history.push("./jobdescription/1");
                    //   this.onCardclick(item);
                    // }}
                  >
                    <div className="c-rounded-rectangle-paper">
                      <p
                        className="c-normal-dark-secondary c-t-bold"
                        style={{ marginBottom: 8 }}
                      >
                        {item.designationname}
                      </p>
                      <div style={{ marginBottom: 8 }}>
                        <img
                          src={department}
                          style={{
                            verticalAlign: "middle",
                            marginRight: 8,
                          }}
                        />
                        <p
                          className="c-small-dark-secondary"
                          style={{ display: "inline", marginBottom: 8 }}
                        >
                          {item.jobtype}
                        </p>
                      </div>
                      <div>
                        <img
                          src={location}
                          style={{
                            verticalAlign: "middle",
                            marginRight: 8,
                          }}
                        />
                        <p
                          className="c-small-dark-secondary"
                          style={{ display: "inline", marginBottom: 8 }}
                        >
                          {item.location && item.location.location}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          {/* <div className="c-chatbutton">
       <div className="c-notification-dot"></div>
       <img src={messageicon} className="c-vertical-center c-msg-icon" />
     </div> */}
        </div>
      </div>
    );
  }
}

export default PreviewCareerPageComp;
